import React, { useState } from 'react';
import { useEventLogsAll } from '../../services/Firestore/Resources';
import EventList from '../../views/Events/EventList';
import withStyles from 'react-jss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const styles = {
  timeSelect: {
    fontSize: '20px',
    width: '300px',
    '& > *': {
      marginBottom: '10px',
    },
  },
  timeSelectGroup: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  datePicker: {
    fontSize: '20px',
    height: '40px',
    width: '200px',
  },
};

const EventsPage = ({ classes }) => {
  const [fromDate, setFromDate] = useState(new Date(Date.now() - 1000 * 60 * 60 * 24 * 7));
  const [toDate, setToDate] = useState(new Date(Date.now() + 1000 * 60 * 60 * 24));

  const limit = 250;
  const [eventLogs, eventLogsLoading] = useEventLogsAll(fromDate, toDate, limit);

  const trySetValidDate = (value, setter) => {
    const date = new Date(value);
    const isValidDate = Date.parse(date);
    isValidDate && setter(date);
  };
  if (eventLogsLoading) {
    return <p>Loading events</p>;
  }
  return (
    <div>
      <div className={classes.timeSelect}>
        <div className={classes.header}>Select a timespan for events</div>
        <div className={classes.timeSelectGroup}>
          <div>From: </div>
          <DatePicker
            selected={fromDate}
            onChange={(date) => trySetValidDate(date, setFromDate)}
            selectsStart
            startDate={fromDate}
            endDate={toDate}
            dateFormat='dd.MM.yyyy'
            className={classes.datePicker}
          />
        </div>
        <div className={classes.timeSelectGroup}>
          <div>To: </div>
          <DatePicker
            selected={toDate}
            onChange={(date) => trySetValidDate(date, setToDate)}
            selectsStart
            startDate={fromDate}
            endDate={toDate}
            dateFormat='dd.MM.yyyy'
            className={classes.datePicker}
          />
        </div>
      </div>
      <EventList events={eventLogs} resultLimit={limit} />
    </div>
  );
};

export default withStyles(styles)(EventsPage);
